import {
  TypesActionsSettings,
  GET_CABYS_CATALOG,
  LATSEST_CABYS_CODES,
  GET_ECONOMIC_ACTIVITY_CATALOG,
  GET_ECONOMIC_ACTIVITY_RESTAURANT,
  RESET_SETTINGS_STATE,
  GET_SETTINGS,
} from '../../../store/actions/settings/SettingTypes';
import { SettingState } from '../../models/settings/SettingsState';

const initialState: SettingState = {
  cabysCatalog: [],
  latestCabysCodes: [],
  economicActivityCatalog: [],
  economicActivityRestaurant: [],
  settings: null,
};

export default function settingsReducer(
  state = initialState,
  action: TypesActionsSettings
) {
  switch (action.type) {
    case GET_CABYS_CATALOG: {
      const cabysCatalog = action.payload;
      return {
        ...state,
        cabysCatalog,
      };
    }
    case LATSEST_CABYS_CODES: {
      const latestCabysCodes = action.payload;
      return {
        ...state,
        latestCabysCodes,
      };
    }
    case GET_ECONOMIC_ACTIVITY_CATALOG: {
      const economicActivityCatalog = action.payload;
      return {
        ...state,
        economicActivityCatalog,
      };
    }
    case GET_ECONOMIC_ACTIVITY_RESTAURANT: {
      const economicActivityRestaurant = action.payload;
      return {
        ...state,
        economicActivityRestaurant,
      };
    }
    case RESET_SETTINGS_STATE: {
      return initialState;
    }
    case GET_SETTINGS: {
      const settings = action.payload;
      return {
        ...state,
        settings,
      };
    }
    default:
      return state;
  }
}
